// GET: /v3/stations/{stationId}/metadata

import { Metadata } from '../../types/Metadata';

function getEndpointUrl(webStationId: string) {
  return `/api/proxy/v3/stations/webStationId:${webStationId}/metadata`;
}

type Params = {
  webStationId: string;
};

type ReturnValue = {
  isExternalSyndicationSetup?: boolean;
  language?: string;
  podcastIsExplicit?: boolean;
  podcastName?: string;
  podcastDescription?: string;
  podcastAuthorName?: string;
  podcastImage?: string;
  podcastCategory?: string;
  podcastLanguage?: string;
  podcastUrlApple?: string;
  podcastUrlGoogle?: string;
  podcastUrlOvercast?: string;
  podcastUrlPocketcasts?: string;
  hasDismissedDistributionMilestone?: boolean;
};

const fetchPodcastMetadata = async (params: Params): Promise<ReturnValue> => {
  const { webStationId } = params;
  const url = getEndpointUrl(webStationId);
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
  });
  if (response.ok) {
    const json = await response.json();
    return json;
  }
  throw new Error(`${response.status} - ${response.statusText}`);
};

export { fetchPodcastMetadata };
